import { render, staticRenderFns } from "./your-library-genres.vue?vue&type=template&id=1ef2adbe"
import script from "./your-library-genres.vue?vue&type=script&setup=true&lang=js"
export * from "./your-library-genres.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports